module.exports = __webpack_public_path__ + "img/award-a.c40ed24f.png";